import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, datas) =>
  await AxiosConfig.create('post', url).call(datas).getResponseData();

const useGetLastMessages = (datas) => {
  const {
    data: messagesDatas,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(`/messages/lastMessages`, (url) => fetcher(url, datas), {
    revalidateOnFocus: false,
  });

  return {
    messagesDatas,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useGetLastMessages;
